"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.branchOpenApiDocs = void 0;
// Branch payload schemas
const BranchCreatePayload = {
    type: 'object',
    description: 'Branch creation request parameters',
    properties: {
        name: {
            type: 'string',
            description: 'Branch name - descriptive title for the industry branch or sector',
            example: 'Technology & Software',
            required: true
        },
        description: {
            type: 'string',
            description: 'Detailed description of the branch, including its focus areas and characteristics',
            example: 'Companies focused on software development, IT services, and technology innovation',
            required: false
        },
        active: {
            type: 'boolean',
            description: 'Whether the branch is currently active and available for selection',
            default: true,
            required: false
        }
    },
    required: ['name']
};
const BranchUpdatePayload = {
    type: 'object',
    description: 'Branch update request parameters',
    properties: {
        name: {
            type: 'string',
            description: 'Updated branch name',
            example: 'Advanced Technology & AI',
            required: false
        },
        description: {
            type: 'string',
            description: 'Updated branch description',
            example: 'Companies specializing in artificial intelligence, machine learning, and cutting-edge technology',
            required: false
        },
        active: {
            type: 'boolean',
            description: 'Updated branch status',
            required: false
        }
    }
};
const BranchResponse = {
    id: {
        type: 'number',
        description: 'Unique branch identifier'
    },
    name: {
        type: 'string',
        description: 'Branch name'
    },
    description: {
        type: 'string',
        description: 'Branch description'
    },
    active: {
        type: 'boolean',
        description: 'Whether the branch is active'
    },
    created_at: {
        type: 'string',
        format: 'date-time',
        description: 'Creation timestamp'
    },
    updated_at: {
        type: 'string',
        format: 'date-time',
        description: 'Last update timestamp'
    }
};
const BranchListResponse = {
    success: {
        type: 'boolean'
    },
    data: {
        type: 'array',
        items: {
            type: 'object',
            properties: BranchResponse
        }
    },
    count: {
        type: 'integer',
        description: 'Total number of branches'
    }
};
exports.branchOpenApiDocs = {
    'branch.list': {
        description: 'List all branches with optional search functionality',
        responses: {
            200: {
                description: 'Branches retrieved successfully',
                returnParams: BranchListResponse
            },
            500: {
                description: 'Internal server error - failed to retrieve branches',
                returnParams: {
                    success: {
                        type: 'boolean'
                    },
                    error: {
                        type: 'string'
                    },
                    error_code: {
                        type: 'integer',
                        description: 'Error code for programmatic handling',
                        example: 5202
                    }
                }
            }
        }
    },
    'branch.create': {
        description: 'Create a new industry branch with name and description',
        payload: {
            body: BranchCreatePayload
        },
        responses: {
            200: {
                description: 'Branch created successfully',
                returnParams: {
                    success: {
                        type: 'boolean'
                    },
                    data: {
                        type: 'object',
                        properties: BranchResponse
                    }
                }
            },
            400: {
                description: 'Bad request - validation error or missing required fields',
                returnParams: {
                    success: {
                        type: 'boolean'
                    },
                    error: {
                        type: 'string'
                    },
                    error_code: {
                        type: 'integer',
                        description: 'Error code for programmatic handling',
                        example: 9005
                    }
                }
            },
            500: {
                description: 'Internal server error - branch creation failed',
                returnParams: {
                    success: {
                        type: 'boolean'
                    },
                    error: {
                        type: 'string'
                    },
                    error_code: {
                        type: 'integer',
                        description: 'Error code for programmatic handling',
                        example: 5202
                    }
                }
            }
        }
    },
    'branch.get': {
        description: 'Get branch by ID',
        responses: {
            200: {
                description: 'Branch retrieved successfully',
                returnParams: {
                    success: {
                        type: 'boolean'
                    },
                    data: {
                        type: 'object',
                        properties: BranchResponse
                    }
                }
            },
            404: {
                description: 'Branch not found',
                returnParams: {
                    success: {
                        type: 'boolean'
                    },
                    error: {
                        type: 'string'
                    },
                    error_code: {
                        type: 'integer',
                        description: 'Error code for programmatic handling',
                        example: 5201
                    }
                }
            },
            500: {
                description: 'Internal server error',
                returnParams: {
                    success: {
                        type: 'boolean'
                    },
                    error: {
                        type: 'string'
                    },
                    error_code: {
                        type: 'integer',
                        description: 'Error code for programmatic handling',
                        example: 5202
                    }
                }
            }
        }
    },
    'branch.update': {
        description: 'Update an existing branch\'s information',
        payload: {
            body: BranchUpdatePayload
        },
        responses: {
            200: {
                description: 'Branch updated successfully',
                returnParams: {
                    success: {
                        type: 'boolean'
                    },
                    data: {
                        type: 'object',
                        properties: BranchResponse
                    }
                }
            },
            400: {
                description: 'Bad request - validation error or invalid parameters',
                returnParams: {
                    success: {
                        type: 'boolean'
                    },
                    error: {
                        type: 'string'
                    },
                    error_code: {
                        type: 'integer',
                        description: 'Error code for programmatic handling',
                        example: 9005
                    }
                }
            },
            404: {
                description: 'Branch not found',
                returnParams: {
                    success: {
                        type: 'boolean'
                    },
                    error: {
                        type: 'string'
                    },
                    error_code: {
                        type: 'integer',
                        description: 'Error code for programmatic handling',
                        example: 5201
                    }
                }
            },
            500: {
                description: 'Internal server error - branch update failed',
                returnParams: {
                    success: {
                        type: 'boolean'
                    },
                    error: {
                        type: 'string'
                    },
                    error_code: {
                        type: 'integer',
                        description: 'Error code for programmatic handling',
                        example: 5203
                    }
                }
            }
        }
    },
    'branch.delete': {
        description: 'Delete branch by ID',
        responses: {
            200: {
                description: 'Branch deleted successfully',
                returnParams: {
                    success: {
                        type: 'boolean'
                    }
                }
            },
            404: {
                description: 'Branch not found',
                returnParams: {
                    success: {
                        type: 'boolean'
                    },
                    error: {
                        type: 'string'
                    },
                    error_code: {
                        type: 'integer',
                        description: 'Error code for programmatic handling',
                        example: 5201
                    }
                }
            },
            500: {
                description: 'Internal server error - branch deletion failed',
                returnParams: {
                    success: {
                        type: 'boolean'
                    },
                    error: {
                        type: 'string'
                    },
                    error_code: {
                        type: 'integer',
                        description: 'Error code for programmatic handling',
                        example: 5204
                    }
                }
            }
        }
    }
};
